var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActoPink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 208.728,
    height: 88.24,
    viewBox: "0 0 208.728 88.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1643",
    "data-name": "Grupo 1643",
    transform: "translate(-203.068 -47.35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_462",
    "data-name": "Grupo 462",
    transform: "translate(203.068 47.35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_548",
    "data-name": "Trazado 548",
    d: "M203.3,127.076l35.434-78.444a2.094,2.094,0,0,1,1.982-1.282h1.165a2.093,2.093,0,0,1,1.98,1.282l35.2,78.444a2.058,2.058,0,0,1-1.982,3.031h-4.663a2.141,2.141,0,0,1-1.98-1.283l-8.625-19.231H220.435l-8.508,19.231a2.145,2.145,0,0,1-1.982,1.283h-4.663A2.057,2.057,0,0,1,203.3,127.076Zm55.364-24.71c-5.711-12.706-11.306-25.527-17.017-38.231h-.932L223.7,102.366Z",
    transform: "translate(-203.068 -47.35)",
    fill: "#5900b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_549",
    "data-name": "Trazado 549",
    d: "M276.311,61.2a20.121,20.121,0,0,1,16.668,8.158,2.281,2.281,0,0,1-.465,3.264L290.3,74.482c-1.747,1.633-2.329.467-3.379-.465a14.384,14.384,0,0,0-10.724-4.9c-8.742,0-15.5,7.226-15.5,16.552s6.643,16.785,15.385,16.785c6.995,0,9.674-3.5,12.356-6.061,1.4-1.4,2.215-1.167,3.5-.233l1.28.932a2.347,2.347,0,0,1,.817,3.264,20.9,20.9,0,0,1-17.834,9.79A23.956,23.956,0,0,1,252.3,85.789C252.3,72.035,263.607,61.2,276.311,61.2Z",
    transform: "translate(-177.698 -40.215)",
    fill: "#5900b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_550",
    "data-name": "Trazado 550",
    d: "M293.3,74.19h-5.943a2.212,2.212,0,0,1-2.214-2.214V69.411a2.142,2.142,0,0,1,2.214-2.214H293.3V54.26a2.293,2.293,0,0,1,2.215-2.215l3.731-.233a2.191,2.191,0,0,1,2.1,2.215V67.2h13.521a2.143,2.143,0,0,1,2.215,2.214v2.565a2.213,2.213,0,0,1-2.215,2.214H301.348v27.274c0,4.663,1.165,5.6,3.847,5.6,2.912,0,6.992-1.749,8.508-2.564,1.749-.933,2.214-.235,2.8.7l1.749,2.914c.815,1.4.465,2.1-.817,2.914-1.632,1.049-7.927,3.962-13.4,3.962-9.325,0-10.725-5.594-10.725-12.821Z",
    transform: "translate(-160.772 -45.051)",
    fill: "#5900b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_551",
    "data-name": "Trazado 551",
    d: "M333.395,61.2c12.939,0,23.2,11.189,23.2,24.36,0,13.4-10.257,24.593-23.2,24.593S310.2,98.96,310.2,85.556C310.2,72.385,320.459,61.2,333.395,61.2Zm0,41.377c8.508,0,15.154-7.575,15.154-17.017,0-9.208-6.646-16.668-15.154-16.668s-15.153,7.46-15.153,16.668C318.242,95,324.886,102.573,333.395,102.573Z",
    transform: "translate(-147.863 -40.215)",
    fill: "#5900b4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_552",
    "data-name": "Trazado 552",
    d: "M337.416,108.225H322.657a3.885,3.885,0,1,1,0-7.77h14.759a3.885,3.885,0,1,1,0,7.77Z",
    transform: "translate(59.622 27.365)",
    fill: "#5900b4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActoPink);
export default __webpack_public_path__ + "static/media/acto-pink.200c564f.svg";
export { ForwardRef as ReactComponent };